<template>
  <div class="gywm">
    <div v-wechat-title="$route.meta.title"></div>

    <div class="dhtBox">
      <div class="cdBox">
        <div class="logo"></div>

        <div @click="shouye" class="cd">首页</div>
        <div @click="fuwu" class="cd">产品服务</div>
        <div @click="sxy" class="cd">商学院</div>
        <div @click="cpgyl" class="cd">产品供应链</div>
        <div @click="hzal" class="cd">合作案例</div>
        <div @click="ydd(hsk)" class="cd yddapp">
          移动端
          <div class="yddxiazai" v-if="hsk == 2">
            <div class="hezi">
              <!-- <div class="img img1"></div> -->
              <!-- <div class="text">米商云</div> -->
            </div>
            <div class="hezi">
              <div class="img img2">
                <img
                  src="../../assets/images/9774f492e19d7134dca0552612911f5.jpg"
                  alt=""
                />
              </div>
              <div class="text">米小礼</div>
            </div>
            <div class="hezi">
              <!-- <div class="img img3"></div> -->
              <!-- <div class="text">商e通</div> -->
            </div>
          </div>
        </div>
        <!-- <div @click="mk" class="cd">米珈</div> -->
        <div @click="gywm" class="cd bxz">关于我们</div>
      </div>
    </div>
    <div class="lbBox">
      <div class="lbttext">
        <div class="text1">关于我们</div>
        <div class="text2">
          米创集团始终遵循以客户为中心，美好生活缔造者的核心理念，从起初专业家居家纺为主的单一型公司发展到如今“嘉佳纺生活”、“米创科技服务平台”两大业务版块双驱并行的综合型公司。公司持续将以互联网新新零售模式为依托，不断致力于为客户提供完整的产品与服务体验，未来成长为平台资源整合商、新零售价值运营商及高品位生活方式的引领企业，最终搭建互联网+产业创新生态圈的商业格局。
        </div>
      </div>
    </div>
    <div class="inboxbox">
      <div class="inbox">
        <div class="text1">新零售运营服务商 - 米创科技</div>
        <div class="text2">
          以互联网技术创新应用为平台，致力为合作企业商家提供新零售运营及品牌经营策划服务，业务包括“积分兑换平台、互联网技术应用
          、新零售运营支持、会员售后服务管理”等四大核心版块。专业为实体商家新零售运营服务，实现流量获客资源、客户维护管理、业绩持续增长、品牌价值提升，提供全方位智慧营销解决方案。
        </div>
        <div class="img1"></div>
        <div class="in2">
          <div class="textbox">
            <div class="img1box">
              <div class="img1s"></div>
              <div class="img2s"></div>
            </div>
            <div class="texts1">
              <span class="color2B7AF5"
                >汇聚技术大牛和营销赋能专业领域营销导师，</span
              >
              <span class="color868686">
                依托行业领先的互联网技术及资深实战的营销赋能专家团队。</span
              >
            </div>
            <div class="texts1">
              <span class="color868686">
                为中小企业商家“新零售运营模式”转型保驾护航。</span
              >
              <span class="color2B7AF5"
                >多维发力，构建运营及售后保障体系。</span
              >
              <!-- <span class="color868686"> 以数据驱动营销，便捷高效掌握客户群便捷高效掌便捷</span> -->
            </div>
            <div class="texts1">
              <span class="color868686">
                提供专业的一对一运营企划指导，帮您快速有效落地实施；</span
              >
              <span class="color2B7AF5">30+运营团队、标准化运营服务模式，</span>
              <span class="color868686"> 提供一站式放心服务。</span>
            </div>
            <div class="texts1">
              <span class="color868686"
                >截至目前，已累积帮助100家年销售额在200万—2000万实体商家企业成功转型新零售，并为众多消费者提供众多优质产品。</span
              >
            </div>
            <div class="texts1">
              <span class="color868686"
                >我们始终相信相信的力量，后续会帮助更多实体商家企业转型新零售。</span
              >
            </div>
          </div>
          <div class="img">
            <div class="textrenming">
              张树江 | <span style="font-size: 0.18rem">&nbsp;董事长</span>
            </div>
          </div>
          <!-- <div class="tuarrat">
            <div class="tus">
              <div class="tuarrattext1">
                管丽华 | <span style="font-size: 0.18rem">&nbsp;CPO</span>
              </div>
              <div class="tusimg1"></div>
            </div>
            <div class="tus">
              <div class="tuarrattext1">
                高现永 | <span style="font-size: 0.18rem">&nbsp;CMO</span>
              </div>
              <div class="tusimg1"></div>
            </div>
            <div class="tus">
              <div class="tuarrattext1">
                董琳慧 | <span style="font-size: 0.18rem">&nbsp;CSO</span>
              </div>
              <div class="tusimg1"></div>
            </div>
          </div> -->
        </div>
      </div>
    </div>
    <div class="renyuanboxbox">
      <div class="renyuanbox">
        <div class="biaoti1">让我们一起合作做一个了不起的项目吧!</div>
        <div class="renyuan_box">
          <div class="remyuan">
            <div class="remyuanimg remyuanimg4"></div>
            <div class="remyuantext1">华东大区</div>
            <div class="remyuantext2">
              吕鸣&nbsp;&nbsp;|&nbsp;&nbsp;<span style="font-size: 0.16rem"
                >大区经理</span
              >
            </div>
            <div class="remyuantext3">联系电话：17717708196</div>
          </div>
          <div class="remyuan">
            <div class="remyuanimg remyuanimg6"></div>
            <div class="remyuantext1">西北大区</div>
            <div class="remyuantext2">
              李春留&nbsp;&nbsp;|&nbsp;&nbsp;<span style="font-size: 0.16rem"
                >大区经理</span
              >
            </div>
            <div class="remyuantext3">联系电话：1771770817</div>
          </div>
 <div class="remyuan">
            <div class="remyuanimg remyuanimg3"></div>
            <div class="remyuantext1">华北大区</div>
            <div class="remyuantext2">
              吕鸣&nbsp;&nbsp;|&nbsp;&nbsp;<span style="font-size: 0.16rem"
                >大区经理</span
              >
            </div>
            <div class="remyuantext3">联系电话：17717708196</div>
          </div>
                    <div class="remyuan">
            <div class="remyuanimg remyuanimg3"></div>
            <div class="remyuantext1">华南大区</div>
            <div class="remyuantext2">
              吕鸣&nbsp;&nbsp;|&nbsp;&nbsp;<span style="font-size: 0.16rem"
                >大区经理</span
              >
            </div>
            <div class="remyuantext3">联系电话：17717708196</div>
          </div>
          <div class="remyuan">
            <div class="remyuanimg remyuanimg7"></div>
            <div class="remyuantext1">华中大区</div>
            <div class="remyuantext2">
              李春留&nbsp;&nbsp;|&nbsp;&nbsp;<span style="font-size: 0.16rem"
                >大区经理</span
              >
            </div>
            <div class="remyuantext3">联系电话：1771770817</div>
          </div>

          <div class="remyuan">
            <div class="remyuanimg remyuanimg5"></div>
            <div class="remyuantext1">西南大区</div>
            <div class="remyuantext2">
              吕鸣&nbsp;&nbsp;|&nbsp;&nbsp;<span style="font-size: 0.16rem"
                >大区经理</span
              >
            </div>
            <div class="remyuantext3">联系电话：17717708196</div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="ditu"></div> -->

    <!--百度地图容器-->
    <div
      style="
        width: 1200px;
        height: 6.5rem;
        border: #ccc solid 1px;
        font-size: 0.12rem;
        margin: 0 auto;
      "
      id="map"
    ></div>
  </div>
</template>
<script>
import API from "@/service/common.service.js";
import BMap from "BMap";

export default {
  data() {
    //

    return {
      active: 0,
      hsk: 1,
      externals: {
        BMap: "BMap",
      },
    };
  },
  mounted() {
    this.ditu();
  },
  methods: {
    ditu() {
      //创建和初始化地图函数：
    function initMap(){
      createMap();//创建地图
      setMapEvent();//设置地图事件
      addMapControl();//向地图添加控件
      addMapOverlay();//向地图添加覆盖物
    }
    function createMap(){ 
      map = new BMap.Map("map"); 
      map.centerAndZoom(new BMap.Point(115.453672,38.924824),17);
    }
    function setMapEvent(){
      map.enableScrollWheelZoom();
      map.enableKeyboard();
      map.enableDragging();
      map.enableDoubleClickZoom()
    }
    function addClickHandler(target,window){
      target.addEventListener("click",function(){
        target.openInfoWindow(window);
      });
    }
    function addMapOverlay(){
      var markers = [
        {content:"",title:"米创集团",imageOffset: {width:-46,height:-21},position:{lat:38.925077,lng:115.453295}}
      ];
      for(var index = 0; index < markers.length; index++ ){
        var point = new BMap.Point(markers[index].position.lng,markers[index].position.lat);
        var marker = new BMap.Marker(point,{icon:new BMap.Icon("http://api.map.baidu.com/lbsapi/createmap/images/icon.png",new BMap.Size(20,25),{
          imageOffset: new BMap.Size(markers[index].imageOffset.width,markers[index].imageOffset.height)
        })});
        var label = new BMap.Label(markers[index].title,{offset: new BMap.Size(25,5)});
        var opts = {
          width: 200,
          title: markers[index].title,
          enableMessage: false
        };
        var infoWindow = new BMap.InfoWindow(markers[index].content,opts);
        marker.setLabel(label);
        addClickHandler(marker,infoWindow);
        map.addOverlay(marker);
      };
    }
    //向地图添加控件
    function addMapControl(){
      var scaleControl = new BMap.ScaleControl({anchor:BMAP_ANCHOR_BOTTOM_LEFT});
      scaleControl.setUnit(BMAP_UNIT_IMPERIAL);
      map.addControl(scaleControl);
      var navControl = new BMap.NavigationControl({anchor:BMAP_ANCHOR_TOP_LEFT,type:BMAP_NAVIGATION_CONTROL_LARGE});
      map.addControl(navControl);
      var overviewControl = new BMap.OverviewMapControl({anchor:BMAP_ANCHOR_BOTTOM_RIGHT,isOpen:true});
      map.addControl(overviewControl);
    }
    var map;
      initMap();
    },
    xuanzhong() {
      console.log(this.active);
    },
    ydd(e) {
      if (e == 1) {
        this.hsk = 2;
      } else {
        this.hsk = 1;
      }
      console.log(this.hsk);
    },
    shouye() {
      this.$router.push({
        path: "/",
      });
    },
    fuwu() {
      this.$router.push({
        path: "/cpfu",
      });
    },
    sxy() {
      this.$router.push({
        path: "/sxy",
      });
    },
    cpgyl() {
      this.$router.push({
        path: "/cpgyl",
      });
    },
    hzal() {
      this.$router.push({
        path: "/hzal",
      });
    },
    mk() {
      this.$router.push({
        path: "/mk",
      });
    },
    gywm() {
      this.$router.push({
        path: "/gywm",
      });
    },
  },
};
</script>
<style lang="scss">
.gywm {

  #map {
    margin-top: 20px;
    height: 700px;
  }
  .dhtBox {
    background: none;
    .logo {
      background: url("../../assets/images/123213.png");
    }
    .cdBox {
      .cd {
        color: #000;
      }
      .cd:hover {
        border-bottom: 2px solid #000000;
      }
      .bxz {
        border-bottom: 2px solid #000;
      }
    }
  }
  .inboxbox {
    width: 100%;
    background: #fff;
    .inbox {
      width: 1200px;
      margin: 0 auto;
      padding-top: 1.3rem;
      .text1 {
        font-size: 0.34rem;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #000000;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 0.48rem;
      }
      .text2 {
        width: 8.97rem;
        font-size: 0.14rem;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #868686;
        line-height: 0.34rem;
        margin: 0 auto;
        text-align: center;
        margin-bottom: 1rem;
      }
      .img1 {
        width: 1200px;
        height: 4.29rem;
        background: url("../../assets/images/1226.png") no-repeat center;
        background-size: 100% 100%;
        margin-bottom: 0.78rem;
      }
      .in2 {
        width: 1200rpx;
        // height: 4.47rem;
        display: flex;
        flex-wrap: wrap;
        padding-bottom: 1.9rem;
        .textbox {
          width: 8rem;

          .img1box {
            display: flex;
            margin-bottom: 0.4rem;
            margin-top: 0.83rem;
            .img1s {
              width: 1.9rem;
              height: 0.3rem;
              background: url("../../assets/images/wmtd.png") no-repeat center;
              background-size: 100% 100%;
              margin-right: 0.3rem;
            }
            .img2s {
              width: 1.9rem;
              height: 0.2rem;
              background: url("../../assets/images/Ourteam.png") no-repeat
                center;
              background-size: 100% 100%;
              margin-top: 0.1rem;
            }
          }
          .color2B7AF5 {
            color: #2b7af5;
          }
          .color868686 {
            color: #868686;
          }
        }
        .texts1 {
          font-size: 0.14rem;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #2b7af5;
          display: flex;
          justify-content: left;
          flex-wrap: wrap;
          margin-bottom: 0.25rem;
        }
        .img {
          width: 3.54rem;
          height: 4.47rem;
          background: url("../../assets/images/1207.png") no-repeat center;
          background-size: 100% 100%;
          position: relative;
          .textrenming {
            width: 100%;
            height: 0.56rem;
            background: #000000;
            opacity: 0.5;
            position: absolute;
            bottom: 0;
            font-size: 0.2rem;
            font-family: Source Han Sans CN;
            font-weight: 500;
            color: #ffffff;
            display: flex;
            justify-content: left;
            align-items: center;
            padding-left: 0.34rem;
            box-sizing: border-box;
          }
        }
        .tuarrat {
          width: 100%;
          height: 4rem;
          margin-top: 0.8rem;
          display: flex;

          .tus {
            width: 3.24rem;
            height: 3.96rem;
            background-size: 100% 100%;
            position: relative;
            margin-right: 0.84rem;
            .tuarrattext1 {
              height: 0.56rem;
              background: #000000;
              opacity: 0.38;
              // background: rgba($color: #000000, $alpha: 0.38);

              display: flex;
              justify-content: left;
              align-items: center;
              font-size: 0.2rem;
              font-family: Source Han Sans CN;
              font-weight: 500;
              color: #ffffff;
              padding-left: 0.34rem;
              box-sizing: border-box;
              position: absolute;
              bottom: 0rem;
              left: 0;
              right: 0;
              margin: auto;
            }
            .tusimg1 {
              width: 1rem;
              height: 1rem;
              background: url("../../assets/images/qwefdd.png") no-repeat center;
              background-size: 100% 100%;
              position: absolute;
              bottom: -0.21rem;
              right: -0.3rem;
            }
          }
          .tus:nth-child(1) {
            background: url("../../assets/images/45b9d919e878b4943e536e7bddff0cb.png")
              no-repeat center;
          }
          .tus:nth-child(2) {
            background: url("../../assets/images/042aabfaa6c8c56fa89667eda466a36.png")
              no-repeat center;
          }
          .tus:nth-child(3) {
            background: url("../../assets/images/06a25de422664a4153e5dcfe1062423.png")
              no-repeat center;
          }
          .tus:nth-child(3) {
            margin-right: 0;
          }
        }
      }
    }
  }
  .lbBox {
    width: 100%;
    height: 7.63rem;
    background: url("../../../src/assets/images/pexels-scott-webb-532568.png");
    background-size: 100% 100%;
    // position: absolute;
    // top: 0;
    z-index: -1;
    margin-top: -0.98rem;
    padding-top: 2.7rem;
    .lbttext {
      width: 1200px;
      margin: 0 auto;
      .text1 {
        font-size: 0.6rem;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #232323;
        margin-bottom: 0.2rem;
      }
      .text2 {
        font-size: 0.18rem;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #232323;
        line-height: 0.38rem;
      }
    }
  }

  .renyuanboxbox {
    width: 100%;
    background: #fbfbfb;
    .renyuanbox {
      width: 1200px;
      margin: 0 auto;
      padding-top: 0.95rem;
      padding-bottom: 0.6rem;
      .biaoti1 {
        font-size: 0.4rem;
        font-family: YouSheBiaoTiHei;
        font-weight: bold;
        color: #2a2e2e;
        text-align: center;
        margin-bottom: 0.8rem;
      }
      .renyuan_box {
        display: flex;
        flex-wrap: wrap;
        .remyuan {
          width: 3.7rem;
          height: 4.38rem;
          background: #ffffff;
          border-radius: 0.2rem;
          margin-right: 0.42rem;
          margin-bottom: 0.6rem;
          padding-top: 0.4rem;
          box-sizing: border-box;
          .remyuanimg {
            width: 1.88rem;
            height: 1.88rem;
            background-size: 100% 100%;
            margin: 0 auto;
            border-radius: 50%;
            // margin-top: 0.4rem;
            margin-bottom: 0.49rem;
          }
          .remyuanimg1 {
            background: url("../../assets/images/c11c347241ce432376c6916cb37a19e.png")
              no-repeat center;
          }
          .remyuanimg2 {
            background: url("../../assets/images/c11c347241ce432376c6916cb37a19e.png")
              no-repeat center;
          }
          .remyuanimg3 {
            background: url("../../assets/images/065c6f78ecd66ab3704550efc568218.png")
              no-repeat center;
          }

          .remyuanimg4 {
            background: url("../../assets/images/065c6f78ecd66ab3704550efc568218.png")
              no-repeat center;
          }
          .remyuanimg5 {
            background: url("../../assets/images/065c6f78ecd66ab3704550efc568218.png")
              no-repeat center;
          }
          .remyuanimg6 {
            background: url("../../assets/images/97e43bc3484360007f6274a65f23c03.png")
              no-repeat center;
          }
          .remyuanimg7 {
            background: url("../../assets/images/97e43bc3484360007f6274a65f23c03.png")
              no-repeat center;
          }
          .remyuantext1 {
            font-size: 0.2rem;
            font-family: Source Han Sans CN;
            font-weight: bold;
            color: #2b7af5;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-bottom: 0.22rem;
          }
          .remyuantext2 {
            font-size: 0.18rem;
            font-family: Source Han Sans CN;
            font-weight: 500;
            color: #2a2e2e;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-bottom: 0.12rem;
          }
          .remyuantext3 {
            font-size: 0.16rem;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #616161;
            display: flex;
            justify-content: center;
            align-items: center;
          }
        }
        .remyuan:nth-child(3n) {
          margin-right: 0;
        }
        .remyuan:hover {
          box-shadow: 0rem 0.03rem 0.16rem 0rem rgba(0, 0, 0, 0.08);
        }
      }
    }
  }
  .ditu {
    width: 100%;
    height: 6.5rem;
    background: url("../../assets/images/1036.png") no-repeat center;
    background-size: 100% 100%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/gywm/index.vue